<div class="row breadcume ps-4" style="width: 100%">
    <div class="col-md-9">
        <div class="row">
            <div class="breadcume-item">
                <h3 style="font-size: 14px" title="Reports">
                    <span>{{ 'IDMS.REPORTS.REPORTS' | transloco }}</span>
                    <i class="fa fa-angle-right" aria-hidden="true" style="font-size: 14px; margin: 0px 5px; color: #337ab7"></i>
                </h3>
            </div>
            <div class="breadcume-item">
                <h3 style="font-size: 14px" title="Default">
                    <span>{{ 'IDMS.REPORTS.DEFAULT' | transloco }}</span>
                    <i class="fa fa-angle-right" aria-hidden="true" style="font-size: 14px; margin: 0px 5px; color: #337ab7"></i>
                </h3>
            </div>
            <div class="breadcume-item">
                <h3 style="font-size: 14px" title="{{ reportName }}">
                    <span>{{ reportName }}</span>
                </h3>
            </div>
        </div>
    </div>
</div>

<div
    class="report-container"
    [ngClass]="['Work Flow Completion', 'View Hierarchy', 'Work Flow Template', 'Activity Progress'].includes(reportName) ? '' : 'fieldRemove'"
>
    <div class="header-content">
        <div class="content">
            <div class="custom-head">
                <a title="{{ 'IDMS.REPORTS.BACK_TO_REPORTS' | transloco }}" (click)="MoveToReports()"
                    ><img src="../../../../../../../assets/media/logos/back-icon.png" alt="back-icon" class="imgReply"
                /></a>
                <h4>
                    <strong>{{ 'IDMS.REPORTS.LOGGED_IN_AS' | transloco }}:</strong> {{ accountName }}
                </h4>
                <h4>
                    <strong>{{ 'IDMS.REPORTS.ORGANIZATION' | transloco }} :</strong> {{ currentOrg }}
                </h4>
                <h4>
                    <strong>{{ 'IDMS.REPORTS.INSTANCE' | transloco }} :</strong> {{ currentInstance }}
                </h4>
            </div>

            <div class="table-content">
                <div class="custom-main-wrapper mb-4" [formGroup]="jccReportform">
                    <div class="custom-form-wrapper" *ngIf="reportName == 'Work Flow Completion'">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.ACTIVITY_PACK_TYPE' | transloco }} :</div>
                        <div>
                            <mat-select
                                #activityPackTypeId
                                formControlName="activityPackTypeId"
                                autocomplete="off"
                                (keydown)="$event.stopPropagation()"
                                multiple
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                            >
                                <mat-form-field [floatLable]="never" class="example-full-width custom-text-field">
                                    <input
                                        matInput
                                        placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                        (keyup)="searchResult($event, 'activityPackTypeId')"
                                    />
                                </mat-form-field>
                                <div class="select-wrapper">
                                    <mat-checkbox class="checkbox-wrap" formControlName="selectAll" (click)="activityPackTypeId.close()">{{
                                        'IDMS.REPORTS.SELECT_ALL' | transloco
                                    }}</mat-checkbox>
                                </div>
                                <mat-option
                                    class="option-list multi-option-list"
                                    [value]="item.activityPackTypeId"
                                    *ngFor="let item of activityPackTypes"
                                    (click)="activityPackTypeId.close()"
                                    >{{ item.name }}</mat-option
                                >
                            </mat-select>
                        </div>
                    </div>

                    <div class="custom-form-wrapper" *ngIf="reportName == 'View Hierarchy'">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.VIEWS' | transloco }} :</div>
                        <div>
                            <mat-select formControlName="viewId" (keydown)="$event.stopPropagation()" class="dropdown-wrapper" panelClass="dropdown-wrapper">
                                <mat-form-field class="example-full-width custom-text-field">
                                    <input
                                        matInput
                                        placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                        autocomplete="off"
                                        (keyup)="searchResult($event, 'viewId')"
                                    />
                                </mat-form-field>
                                <mat-option class="option-list" [value]="item.viewId" *ngFor="let item of Views">{{ item.name }}</mat-option>
                            </mat-select>
                        </div>
                    </div>

                    <div class="custom-form-wrapper" *ngIf="reportName == 'Work Flow Template'">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.FROM' | transloco }}:</div>
                        <div>
                            <dx-date-box
                                class="dx-date-custom-wrapper"
                                formControlName="from_date"
                                displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                (dateChange)="detectValueChanges($event)"
                                [disabled]="isEditEnabled === false"
                                blockDateTyping
                            >
                            </dx-date-box>
                        </div>
                    </div>

                    <div class="custom-form-wrapper" *ngIf="reportName == 'Work Flow Template'">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.ACTIVITY_PACK_TYPE' | transloco }} :</div>
                        <div>
                            <mat-select
                                formControlName="activityPackTypeId"
                                (keydown)="$event.stopPropagation()"
                                class="form-field-wrapper"
                                [disabled]="!activityPackTypes || activityPackTypes?.length == 0"
                                *ngIf="activityPackTypesCopy?.length > 0"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                            >
                                <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                                    <input
                                        matInput
                                        placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                        autocomplete="off"
                                        (keyup)="searchResult($event, 'activityPackTypeId')"
                                    />
                                </mat-form-field>
                                <mat-option class="option-list" [value]="item.activityPackTypeId" *ngFor="let item of activityPackTypes">{{
                                    item.name
                                }}</mat-option>
                            </mat-select>

                            <mat-form-field class="example-full-width custom-text-field" *ngIf="activityPackTypesCopy?.length == 0">
                                <mat-select class="dropdown-wrapper" panelClass="dropdown-wrapper" formControlName="activityPackTypeId">
                                    <mat-option class="option-list" value="-1">{{ 'IDMS.REPORTS.NA' | transloco }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="custom-form-wrapper" *ngIf="reportName == 'Work Flow Template'">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.ACTIVITY_PACK_STATUS' | transloco }}:</div>
                        <div>
                            <mat-select
                                #activityPackTypeStatusId
                                formControlName="activityPackTypeStatusId"
                                autocomplete="off"
                                (keydown)="$event.stopPropagation()"
                                multiple
                                [disabled]="!activityPackStatus || activityPackStatus?.length == 0"
                                *ngIf="activityPackStatusCopy?.length > 0"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                            >
                                <mat-form-field [floatLable]="never" class="example-full-width custom-text-field">
                                    <input
                                        matInput
                                        placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                        (keyup)="searchResult($event, 'activityPackTypeStatusId')"
                                    />
                                </mat-form-field>
                                <div class="select-wrapper">
                                    <mat-checkbox
                                        class="checkbox-wrap"
                                        formControlName="activityPackTypeStatusselectAll"
                                        (click)="activityPackTypeStatusId.close()"
                                        >{{ 'IDMS.REPORTS.SELECT_ALL' | transloco }}</mat-checkbox
                                    >
                                </div>
                                <mat-option
                                    class="option-list multi-option-list"
                                    [value]="item.activityPackTypeStatusId"
                                    *ngFor="let item of activityPackStatus"
                                    (click)="activityPackTypeStatusId.close()"
                                    >{{ item.name }}</mat-option
                                >
                            </mat-select>

                            <mat-select
                                #activityPackTypeStatusId
                                formControlName="activityPackTypeStatusId"
                                *ngIf="!activityPackStatusCopy"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                            >
                                <mat-option value="-1" class="option-list">{{ 'IDMS.REPORTS.NA' | transloco }}</mat-option>
                            </mat-select>
                        </div>
                    </div>

                    <div class="custom-form-wrapper" *ngIf="reportName == 'Work Flow Template'">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.ACTIVITY_PACK' | transloco }}:</div>
                        <div>
                            <mat-select
                                #activityPackId
                                formControlName="activityPackId"
                                autocomplete="off"
                                (keydown)="$event.stopPropagation()"
                                multiple
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                *ngIf="activityPacksCopy?.length"
                            >
                                <mat-form-field [floatLable]="never" class="example-full-width custom-text-field">
                                    <input matInput placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}" (keyup)="searchResult($event, 'activityPackId')" />
                                </mat-form-field>
                                <div class="select-wrapper">
                                    <mat-checkbox class="checkbox-wrap" formControlName="activityPackIdselectAll" (click)="activityPackId.close()">{{
                                        'IDMS.REPORTS.SELECT_ALL' | transloco
                                    }}</mat-checkbox>
                                </div>
                                <mat-option
                                    class="option-list multi-option-list"
                                    [value]="item.activityPackId"
                                    *ngFor="let item of activityPacks"
                                    (click)="activityPackId.close()"
                                    >{{ item.namePrimary }}</mat-option
                                >
                            </mat-select>

                            <mat-select
                                formControlName="activityPackId"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                *ngIf="!activityPacksCopy?.length"
                            >
                                <mat-option class="option-list" value="-1">{{ 'IDMS.REPORTS.NA' | transloco }}</mat-option>
                            </mat-select>
                        </div>
                    </div>

                    <div class="custom-form-wrapper" *ngIf="reportName == 'Activity Progress'">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.PROJECT_TYPE' | transloco }} :</div>
                        <div>
                            <mat-select
                                [disabled]="!projectTypes || projectTypes?.length == 0"
                                formControlName="projectTypeId"
                                (keydown)="$event.stopPropagation()"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                            >
                                <mat-form-field class="custom-text-field example-full-width">
                                    <input
                                        matInput
                                        placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                        autocomplete="off"
                                        (keyup)="searchResult($event, 'projectTypeId')"
                                    />
                                </mat-form-field>
                                <mat-option class="option-list" [value]="item.projectTypeId" *ngFor="let item of projectTypes">{{ item.name }}</mat-option>
                            </mat-select>
                        </div>
                    </div>

                    <div class="custom-form-wrapper" *ngIf="reportName == 'Activity Progress'">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.PROJECT' | transloco }} :</div>
                        <div>
                            <mat-select
                                formControlName="projectId"
                                (keydown)="$event.stopPropagation()"
                                class="form-field-wrapper"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                [disabled]="!projects || projectsCopy?.length == 0"
                            >
                                <mat-form-field class="custom-text-field example-full-width">
                                    <input
                                        matInput
                                        placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                        autocomplete="off"
                                        (keyup)="searchResult($event, 'projectId')"
                                    />
                                </mat-form-field>
                                <mat-option class="option-list" [value]="item.projectId" *ngFor="let item of projects">{{ item.namePrimary }}</mat-option>
                            </mat-select>
                        </div>
                    </div>

                    <div class="custom-form-wrapper" *ngIf="reportName == 'Pack Sheet'">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.PROJECT' | transloco }} :</div>
                        <!-- <div>
                            <mat-select
                                formControlName="projectId"
                                (keydown)="$event.stopPropagation()"
                                class="form-field-wrapper"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                [disabled]="!projects || projectsCopy?.length == 0"
                            >
                                <mat-form-field class="custom-text-field example-full-width">
                                    <input
                                        matInput
                                        placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}"
                                        autocomplete="off"
                                        (keyup)="searchResult($event, 'projectId')"
                                    />
                                </mat-form-field>
                                <mat-option class="option-list" [value]="item.projectId" *ngFor="let item of projects">{{ item.namePrimary }}</mat-option>
                            </mat-select>
                        </div> -->
                        <div>
                            <mat-select
                                #projectIds
                                formControlName="projectIds"
                                autocomplete="off"
                                (keydown)="$event.stopPropagation()"
                                multiple
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                *ngIf="packSheetprojectsCopy?.length"
                            >
                                <mat-form-field [floatLable]="never" class="example-full-width custom-text-field">
                                    <input matInput placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}" (keyup)="searchResult($event, 'projectIds')" />
                                </mat-form-field>
                                <div class="select-wrapper">
                                    <mat-checkbox class="checkbox-wrap" formControlName="projectIdselectAll" (click)="projectIds.close()">{{
                                        'IDMS.REPORTS.SELECT_ALL' | transloco
                                    }}</mat-checkbox>
                                </div>
                                <mat-option class="option-list multi-option-list" [value]="item.projectId" *ngFor="let item of packSheetprojects">{{
                                    item.namePrimary
                                }}</mat-option>
                            </mat-select>
                            <!-- (click)="projectIds.close()" -->
                            <mat-select
                                formControlName="projectId"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                *ngIf="!packSheetprojectsCopy?.length"
                            >
                                <mat-option class="option-list" value="-1">{{ 'IDMS.REPORTS.NA' | transloco }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div class="custom-form-wrapper" *ngIf="reportName == 'Pack Sheet'">
                        <div class="labelWrap">{{ 'IDMS.REPORTS.ACTIVITY_PACK' | transloco }}:</div>
                        <div>
                            <mat-select
                                #activityPackIddrp
                                formControlName="activityPackIddrp"
                                autocomplete="off"
                                (keydown)="$event.stopPropagation()"
                                multiple
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                *ngIf="packSheetWorkPacksCopy?.length"
                            >
                                <mat-form-field [floatLable]="never" class="example-full-width custom-text-field">
                                    <input matInput placeholder="{{ 'IDMS.REPORTS.SEARCH' | transloco }}" (keyup)="searchResult($event, 'activityPackIddrp')" />
                                </mat-form-field>
                                <div class="select-wrapper">
                                    <mat-checkbox class="checkbox-wrap" formControlName="activityPackIddrpselectAll" (click)="activityPackIddrp.close()">{{
                                        'IDMS.REPORTS.SELECT_ALL' | transloco
                                    }}</mat-checkbox>
                                </div>
                                <mat-option class="option-list multi-option-list" [value]="item.activityPackId" *ngFor="let item of packSheetWorkPacks">{{
                                    item.namePrimary
                                }}</mat-option>
                            </mat-select>
                            <!-- (click)="activityPackIddrp.close()"
                             
                              -->
                            <mat-select
                                formControlName="activityPackIddrp"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                *ngIf="!packSheetWorkPacksCopy?.length"
                            >
                                <mat-option class="option-list" value="-1">{{ 'IDMS.REPORTS.NA' | transloco }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div class="custom-form-wrapper" *ngIf="reportName == 'Dashboard'"></div>
                    <div class="custom-form-wrapper" *ngIf="reportName == 'Dashboard'"></div>
                    <div
                        class="custom-btn"
                        *ngIf="
                            (ActivityProgressData && reportName == 'Activity Progress') ||
                            reportName == 'Pack Sheet' ||
                            (reportName == 'Dashboard' &&
                                (dashboardData?.blocks || dashboardData?.charts || dashboardData?.kpiPercentages || dashboardData?.summary))
                        "
                    >
                        <a href="javascript:void(0)" style="float: right">
                            <i
                                style="font-size: 23px"
                                class="far fa-share-square"
                                #tooltip="matTooltip"
                                matTooltip="{{ 'IDMS.REPORTS.EXPORT_TO_PDF' | transloco }}"
                                [matTooltipPosition]="tooltip_position"
                                (click)="ExportToPDf()"
                            ></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="reportName !== 'Activity Progress' && enableReport; else activityOrCustomCheck">
        <div class="dx-table-wrapper">
            <dx-data-grid
                #dataGrid
                [dataSource]="customDataSource"
                [columns]="columns"
                [showBorders]="true"
                [showRowLines]="true"
                [showColumnLines]="false"
                [allowColumnResizing]="true"
                [columnAutoWidth]="true"
                [wordWrapEnabled]="true"
                (onExporting)="onExporting($event)"
                [sorting]="'none'"
                [remoteOperations]="true"
                class="wrapped-grid"
            >
                <!-- width="100%" -->
                <!--<dxo-search-panel [visible]="true"></dxo-search-panel>[columnWidth]="200"-->
                <dxo-scrolling></dxo-scrolling>
                <dxo-paging [pageSize]="pageSize"></dxo-paging>
                <dxo-pager [visible]="true" [displayMode]="'compact'" [showNavigationButtons]="true"></dxo-pager>
                <dxo-export [enabled]="true" [formats]="filteredFormats"></dxo-export>
                <dxo-load-panel [enabled]="false"></dxo-load-panel>
                <div *dxTemplate="let d of 'diffCellTemplate'">
                    <ng-container *ngIf="splitData(d)?.length > 0">
                        <div *ngFor="let item of splitData(d)">
                            <span>{{ replaceSymbols(item) }}</span>
                            <br />
                        </div>
                    </ng-container>
                    <ng-container *ngIf="splitData(d)?.length == 0">
                        {{ d.value }}
                    </ng-container>
                </div>
                <dxo-remote-operations> </dxo-remote-operations>
            </dx-data-grid>
        </div>
        <div *ngIf="customDataSource?.length === 0" class="d-flex align-items-center justify-content-center w-100 h-100">
            <p class="no-data-report">{{ 'IDMS.REPORTS.NO_DATA_TO_DISPLAY' | transloco }}</p>
        </div>
    </div>

    <!-- Activity / Custom fallback -->
    <ng-template #activityOrCustomCheck>
        <ng-container *ngIf="reportName === 'Activity Progress' && ActivityProgressData; else customCheck">
            <app-activity-progress-report [ActivityProgressData]="ActivityProgressData"> </app-activity-progress-report>
        </ng-container>
    </ng-template>

    <!-- Custom report -->
    <ng-template #customCheck>
        <ng-container *ngIf="reportName === 'Dashboard'; else elseBlock">
            <app-custom-dashboard *ngIf="dashboardData" [dashboardData]="dashboardData"></app-custom-dashboard>
        </ng-container>
    </ng-template>
</div>

<ng-template #elseBlock>
    <div class="view-report-nodata">
        <h1 *ngIf="reportName != 'Pack Sheet'">{{ 'IDMS.REPORTS.NO_DATA_TO_DISPLAY' | transloco }}</h1>
        <h4 *ngIf="reportName != 'Pack Sheet'">{{ 'IDMS.REPORTS.PLEASE_USE_FILTERS_TO_DISPLAY_RESULT' | transloco }}</h4>
        <h4 *ngIf="reportName === 'Pack Sheet'">{{ 'IDMS.REPORTS.YOUR_REPORT_HAS_BEEN_GENERATED_AND_OPENED_IN_A_NEW_TAB' | transloco }}</h4>
    </div>
</ng-template>
